import { getSocket } from './socket'

// Mirror the client-allowed taxonomy on the server
// (CLIENT_ACTIVITY_TYPES in voiceActivityEvents.ts).
export type ClientActivityType =
  | 'soundboard' | 'reaction' | 'hand_raise' | 'hand_lower'
  | 'away_on' | 'away_off' | 'device_mic' | 'device_output' | 'device_camera'

// Fire-and-forget. The server validates membership + stamps actor/time,
// then broadcasts voice:activity back to the room (incl. this client),
// which is how the event reaches the live feed — we do NOT optimistically
// append locally, so the sender and observers render identically.
export function emitVoiceActivity(
  channelId: string | null | undefined,
  type: ClientActivityType,
  meta?: Record<string, unknown>,
): void {
  if (!channelId) return
  try { getSocket().emit('voice:activity', { channelId, type, meta }) } catch { /* socket not ready */ }
}
